if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.index = this.dataset.itemIndex; /* Index of the product in a product grid */
      this.enableScrollIntercept = this.dataset.scrollIntercept === 'true'; /* Enable scroll intercept for quick buy button */

      if (this.enableScrollIntercept) {
        this.addEventListener('click', (event) => {
          this.linkIntercept(event);
        });
      }

      this.querySelector('.product-card__heading a')?.addEventListener('click', (event) => {

        let itemData = this.querySelector('template').innerHTML;
        itemData = JSON.parse(itemData);
        itemData.index = parseInt(this.index);

        document.dispatchEvent(new CustomEvent('product-card:selected', {
          detail: {
            action: 'select_item',
            location: 'PCP Collection',
            item: itemData
          }
        }));
      });

      const self = this;

      self.setHoverImageStyle();


      window.addEventListener('load', () => {
        this.handleImageDisplayNone();
      });

      this.addEventListener('mouseenter', this.loadSwatchImages, { once: true });

      // Elevar
      this.productCardDataTemplate = this.querySelector('template');
      this.elevarTemplate = document.querySelector('#elevar-atc-custom-data');
      this.quickBuyButton = this.querySelector('quickbuy-button') || this.querySelector('product-form');

      if (this.productCardDataTemplate && this.elevarTemplate && this.quickBuyButton) {
        this.quickBuyButton.addEventListener('click', () => {
          this.updateElevarTemplateData();
        });
      }
    }

    setHoverImageStyle() {
      const image = this.querySelector('.product-card__image[style*="display: none"]');
      if (image) {
        image.style.removeProperty('display');
      }
    }

    handleImageDisplayNone() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const image = entry.target.querySelector('.product-card__image[style*="display: none"]');
            if (image) {
              image.style.removeProperty('display');
              observer.unobserve(entry.target);
            }
          }
        });
      });

      observer.observe(this);
    }

    // Full swatch-options row is only revealed on desktop hover (see component-product-card.css);
    // its images use data-bg instead of an eager background-image so they're not fetched for every
    // card on grid load, only once a card is actually hovered.
    loadSwatchImages = () => {
      this.querySelectorAll('.product-group--item__swatch[data-bg]').forEach((swatch) => {
        swatch.style.backgroundImage = `url(${swatch.dataset.bg})`;
        swatch.removeAttribute('data-bg');
      });
      this.dataset.swatchImagesLoaded = 'true';
    };

    updateElevarTemplateData() {

      if (!this.elevarTemplate || !this.productCardDataTemplate) return;

      const productCardData = JSON.parse(this.productCardDataTemplate.innerHTML);
      const elevarData = JSON.parse(this.elevarTemplate.innerHTML);

      elevarData.product_mid = productCardData.mid;
      elevarData.product_team = productCardData.team;
      elevarData.product_silhouette = productCardData.silhouette;
      elevarData.product_license = productCardData.sport;
      elevarData.country = productCardData.market;

      this.elevarTemplate.innerHTML = JSON.stringify(elevarData);
    }

    linkIntercept(event) {
      if (event.target.closest('quickbuy-button') || event.target.closest('product-form') || event.target.closest('.product-card__wishlist-button') || event.target.closest('.price__badge-members-only') || event.target.closest('product-group')) {
        return;
      } else if (event.target.closest('product-card') && event.target.closest('#product-grid')) {
        event.preventDefault();
        const variantID = event.target.closest('li.grid__item').dataset.variantId;
        const collectionHandle = event.target.closest('#product-grid').dataset.collectionHandle;

        if (variantID && collectionHandle) {
          this.setLastVisitedProductInSessionStorage(variantID, collectionHandle);
        }

        window.location.href = event.target.closest('product-card').querySelector('.product-card__heading a').href;
      }
    }

    setLastVisitedProductInSessionStorage(variantID, collectionHandle) {
      sessionStorage.setItem("lastVisitedProduct", JSON.stringify({ variantID, collectionHandle }));
    }
  }

  customElements.define("product-card", ProductCard);
}